module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel10-663647400b51a665313a4254a8a1ba7d.jpg";